function makeCells(x, y, count, width = 17.6, height = 15, gap = 0, fontSize = 10) {
  return Array.from({ length: count }, (_, index) => ({
    x: x + index * (width + gap),
    y,
    width,
    height,
    fontSize,
  }));
}

function makeCellGroups(groups) {
  return groups.flatMap((group) =>
    makeCells(
      group.x,
      group.y,
      group.count,
      group.width,
      group.height,
      group.gap,
      group.fontSize
    )
  );
}

export const CLAIM_FORM_TEMPLATES = {
  dbInsurance: {
    companyId: 'dbFire',
    companyName: 'DB손해보험',
    aliases: ['DB손보'],
    formUrl: '/insurance-forms/DB손해보험금청구서.pdf',
    outputName: 'DB손해보험_보험금청구서',
    formVersion: 'db_fire_claim_2026_08',
    expectedPageCount: 6,
    pageMap: {
      claim: 0,
      collectConsent: 3,
      provideConsent: 4,
      queryConsent: 5,
    },
    uiSchema: {
      fields: {
        birth: true,
        accidentTime: true,
        noticeRecipient: true,
        receiptType: true,
        receiveSamePerson: true,
        autoTransferRequest: true,
        beneficiary: true,
      },
      receiptTypeOptions: ['initial', 'additional'],
    },
    pageSize: { width: 595.276, height: 841.89 },
    // page is pdf-lib's 0-based page index. The DB form's printed pages are not
    // contiguous in the source PDF: printed [1/4] is page 0, [2/4] is page 3,
    // [3/4] is page 4, and [4/4] is page 5.
    fields: {
      insuredName: { page: 0, formPage: '1/4', x: 144, y: 690, width: 95, height: 15, fontSize: 10 },
      ssn: { page: 0, formPage: '1/4', x: 308, y: 690, width: 108, height: 15, fontSize: 10 },
      job: { page: 0, formPage: '1/4', x: 478, y: 668, width: 68, height: 15, fontSize: 9 },
      address: { page: 0, formPage: '1/4', x: 170, y: 642, width: 345, height: 17, fontSize: 9 },
      phone: { page: 0, formPage: '1/4', x: 150, y: 600, width: 84, height: 15, fontSize: 9 },
      accidentYear: { page: 0, formPage: '1/4', x: 108, y: 458, width: 34, height: 15, fontSize: 10 },
      accidentMonth: { page: 0, formPage: '1/4', x: 160, y: 458, width: 18, height: 15, fontSize: 10 },
      accidentDay: { page: 0, formPage: '1/4', x: 199, y: 458, width: 18, height: 15, fontSize: 10 },
      accidentHour: { page: 0, formPage: '1/4', x: 226, y: 458, width: 18, height: 15, fontSize: 10 },
      accidentMinute: { page: 0, formPage: '1/4', x: 261, y: 458, width: 18, height: 15, fontSize: 10 },
      diagnosis: { page: 0, formPage: '1/4', x: 390, y: 458, width: 140, height: 15, fontSize: 10 },
      treatmentHospital: { page: 0, formPage: '1/4', x: 390, y: 430, width: 140, height: 15, fontSize: 10 },
      claimDescription: { page: 0, formPage: '1/4', x: 106, y: 386, width: 410, height: 36, fontSize: 9 },
      accountNumber: { page: 0, formPage: '1/4', x: 170, y: 276, width: 170, height: 15, fontSize: 10 },
      bank: { page: 0, formPage: '1/4', x: 410, y: 276, width: 70, height: 15, fontSize: 10 },
      accountHolder: { page: 0, formPage: '1/4', x: 510, y: 276, width: 42, height: 15, fontSize: 9 },
      writtenYear: { page: 0, formPage: '1/4', x: 74, y: 139, width: 38, height: 15, fontSize: 10 },
      writtenMonth: { page: 0, formPage: '1/4', x: 141, y: 139, width: 24, height: 15, fontSize: 10 },
      writtenDay: { page: 0, formPage: '1/4', x: 192, y: 139, width: 30, height: 15, fontSize: 10 },
      signatureName: { page: 0, formPage: '1/4', x: 420, y: 139, width: 82, height: 15, fontSize: 9 },
      signature: { page: 0, formPage: '1/4', x: 502, y: 140, width: 48, height: 24 },
      beneficiaryNamePage1: { page: 0, formPage: '1/4', x: 420, y: 105, width: 82, height: 15, fontSize: 9 },
      beneficiarySignaturePage1: { page: 0, formPage: '1/4', x: 502, y: 106, width: 48, height: 24 },
      consentWrittenYear: { page: 5, formPage: '4/4', x: 76, y: 115, width: 38, height: 15, fontSize: 10 },
      consentWrittenMonth: { page: 5, formPage: '4/4', x: 145, y: 115, width: 24, height: 15, fontSize: 10 },
      consentWrittenDay: { page: 5, formPage: '4/4', x: 196, y: 115, width: 30, height: 15, fontSize: 10 },
      consentSignatureName: { page: 5, formPage: '4/4', x: 420, y: 115, width: 82, height: 15, fontSize: 9 },
      consentSignature: { page: 5, formPage: '4/4', x: 506, y: 116, width: 48, height: 26 },
      beneficiaryName: { page: 5, formPage: '4/4', x: 420, y: 84, width: 82, height: 15, fontSize: 9 },
      beneficiarySignature: { page: 5, formPage: '4/4', x: 506, y: 86, width: 48, height: 24 },
      noticeOtherName: { page: 0, formPage: '1/4', x: 272, y: 622, width: 90, height: 15, fontSize: 9 },
      noticeOtherRelation: { page: 0, formPage: '1/4', x: 470, y: 622, width: 62, height: 15, fontSize: 9 },
    },
    checkboxes: {
      claimType: {
        injury: { page: 0, formPage: '1/4', x: 124.8, y: 494.4, size: 7.2, lineWidth: 2 },
        disease: { page: 0, formPage: '1/4', x: 165.4, y: 494.4, size: 7.2, lineWidth: 2 },
        traffic: { page: 0, formPage: '1/4', x: 205.9, y: 494.4, size: 7.2, lineWidth: 2 },
        other: { page: 0, formPage: '1/4', x: 246.5, y: 494.4, size: 7.2, lineWidth: 2 },
      },
      receiptType: {
        initial: { page: 0, formPage: '1/4', x: 400.6, y: 494.4, size: 7.2, lineWidth: 2 },
        additional: { page: 0, formPage: '1/4', x: 457.7, y: 494.4, size: 7.2, lineWidth: 2 },
      },
      noticeRecipient: {
        policyholder: { page: 0, formPage: '1/4', x: 111.4, y: 626.4, size: 7.2, lineWidth: 2 },
        insured: { page: 0, formPage: '1/4', x: 167.5, y: 626.4, size: 7.2, lineWidth: 2 },
        other: { page: 0, formPage: '1/4', x: 215.5, y: 626.4, size: 7.2, lineWidth: 2 },
      },
      autoTransferRequest: { page: 0, formPage: '1/4', x: 139.4, y: 315.4, size: 6.4, lineWidth: 1.8 },
    },
    consents: {
      collectUniqueId: {
        label: '고유식별정보 수집·이용 동의',
        required: true,
        page: 3,
        formPage: '2/4',
        agree: { x: 540.4, y: 436.2, size: 12.5, lineWidth: 2.8 },
      },
      collectSensitive: {
        label: '민감정보 수집·이용 동의',
        required: true,
        page: 3,
        formPage: '2/4',
        agree: { x: 540.4, y: 344, size: 12.5, lineWidth: 2.8 },
      },
      collectPersonalCredit: {
        label: '개인(신용)정보 수집·이용 동의',
        required: true,
        page: 3,
        formPage: '2/4',
        agree: { x: 540.4, y: 249.2, size: 12.5, lineWidth: 2.8 },
      },
      provideUniqueId: {
        label: '고유식별정보 제공 동의',
        required: true,
        page: 4,
        formPage: '3/4',
        agree: { x: 540.4, y: 403.8, size: 12.5, lineWidth: 2.8 },
      },
      provideSensitive: {
        label: '민감정보 제공 동의',
        required: true,
        page: 4,
        formPage: '3/4',
        agree: { x: 540.4, y: 306.1, size: 12.5, lineWidth: 2.8 },
      },
      providePersonalCredit: {
        label: '개인(신용)정보 제공 동의',
        required: true,
        page: 4,
        formPage: '3/4',
        agree: { x: 540.4, y: 178.4, size: 12.5, lineWidth: 2.8 },
      },
      providePersonalCreditContinued: {
        label: '개인(신용)정보 제공 동의',
        required: false,
        mirrorOf: 'providePersonalCredit',
        page: 5,
        formPage: '4/4',
        agree: { x: 540.2, y: 624.6, size: 12.5, lineWidth: 2.8 },
      },
      queryUniqueId: {
        label: '고유식별정보 조회 동의',
        required: true,
        page: 5,
        formPage: '4/4',
        agree: { x: 540.2, y: 352.2, size: 12.5, lineWidth: 2.8 },
      },
      querySensitive: {
        label: '민감정보 조회 동의',
        required: true,
        page: 5,
        formPage: '4/4',
        agree: { x: 540.2, y: 286.4, size: 12.5, lineWidth: 2.8 },
      },
      queryPersonalCredit: {
        label: '개인(신용)정보 조회 동의',
        required: true,
        page: 5,
        formPage: '4/4',
        agree: { x: 540.2, y: 158.8, size: 12.5, lineWidth: 2.8 },
      },
    },
  },
  kbInsurance: {
    companyId: 'kbFire',
    companyName: 'KB손해보험',
    aliases: ['KB손보'],
    formUrl: '/insurance-forms/KB손해.pdf',
    outputName: 'KB손해보험_보험금청구서',
    formVersion: 'kb_fire_claim_2021_05',
    expectedPageCount: 4,
    pageSize: { width: 595.276, height: 841.89 },
    // page is pdf-lib's 0-based page index. KB's source PDF is:
    // page 0 = claim form [1/3], page 1 = consent [2/3],
    // page 2 = consent [3/3], page 3 = 안내문 only.
    pageMap: {
      claim: 0,
      collectConsent: 1,
      provideAndQueryConsent: 2,
      guide: 3,
    },
    uiSchema: {
      fields: {
        birth: true,
        accidentTime: false,
        noticeRecipient: true,
        receiptType: true,
        receiveSamePerson: false,
        autoTransferRequest: true,
        policyholder: true,
        beneficiary: false,
      },
      claimTypeOptions: ['injury', 'disease', 'traffic'],
      receiptTypeOptions: ['additional'],
      autoTransferRequestLabel: '자동이체계좌로 송금 요청',
      partialClaimCoverageOptions: [
        { value: 'inpatient', label: '입원' },
        { value: 'outpatient', label: '통원' },
        { value: 'surgery', label: '수술' },
        { value: 'diagnosis', label: '진단' },
        { value: 'death', label: '사망' },
        { value: 'disability', label: '장해' },
        { value: 'driver', label: '운전자' },
      ],
      autoInsuranceProcessedOptions: [
        { value: 'no', label: '아니오' },
        { value: 'yes', label: '예' },
      ],
      vehicleOccupantOptions: [
        { value: 'driver', label: '운전석' },
        { value: 'frontPassenger', label: '조수석' },
        { value: 'rearPassenger', label: '뒷좌석' },
        { value: 'pedestrian', label: '보행중' },
        { value: 'other', label: '기타' },
      ],
      optionalConsentTitle: '선택 동의',
    },
    fields: {
      insuredName: { page: 0, formPage: '1/3', x: 136, y: 722, width: 90, height: 16, fontSize: 10 },
      ssn: {
        page: 0,
        formPage: '1/3',
        fontSize: 9.5,
        digitsOnly: true,
        cellBoxes: makeCellGroups([
          { x: 288.5, y: 722.5, count: 6, width: 17.8, height: 15 },
          { x: 415, y: 722.5, count: 7, width: 17.8, height: 15 },
        ]),
      },
      policyholderName: { page: 0, formPage: '1/3', x: 136, y: 646.5, width: 90, height: 16, fontSize: 10 },
      policyholderSsn: {
        page: 0,
        formPage: '1/3',
        fontSize: 9.5,
        digitsOnly: true,
        valign: 'center',
        cellBoxes: makeCellGroups([
          { x: 288.5, y: 646.5, count: 6, width: 17.8, height: 15 },
          { x: 415, y: 646.5, count: 7, width: 17.8, height: 15 },
        ]),
      },
      phone: {
        page: 0,
        formPage: '1/3',
        fontSize: 9.5,
        digitsOnly: true,
        cellBoxes: makeCellGroups([
          { x: 144.5, y: 697.5, count: 3, width: 18, height: 15 },
          { x: 214, y: 697.5, count: 4, width: 18, height: 15 },
          { x: 301.5, y: 697.5, count: 4, width: 18, height: 15 },
        ]),
      },
      noticePhone: {
        page: 0,
        formPage: '1/3',
        fontSize: 9.5,
        digitsOnly: true,
        valign: 'center',
        cellBoxes: makeCellGroups([
          { x: 144.5, y: 594.5, count: 3, width: 18, height: 15 },
          { x: 214, y: 594.5, count: 4, width: 18, height: 15 },
          { x: 301.5, y: 594.5, count: 4, width: 18, height: 15 },
        ]),
      },
      job: { page: 0, formPage: '1/3', x: 455, y: 697, width: 80, height: 16, fontSize: 9 },
      address: { page: 0, formPage: '1/3', x: 130, y: 671, width: 335, height: 17, fontSize: 9 },
      noticeOtherName: { page: 0, formPage: '1/3', x: 355, y: 614, width: 65, height: 14, fontSize: 9 },
      noticeOtherRelation: { page: 0, formPage: '1/3', x: 468, y: 614, width: 58, height: 14, fontSize: 9 },
      accidentYear: { page: 0, formPage: '1/3', fontSize: 9.5, digitsOnly: true, cellBoxes: makeCells(107.5, 435.5, 4, 18, 15) },
      accidentMonth: { page: 0, formPage: '1/3', fontSize: 9.5, digitsOnly: true, cellBoxes: makeCells(197, 435.5, 2, 18, 15) },
      accidentDay: { page: 0, formPage: '1/3', fontSize: 9.5, digitsOnly: true, cellBoxes: makeCells(245.5, 435.5, 2, 18, 15) },
      claimDescription: { page: 0, formPage: '1/3', x: 74, y: 390, width: 215, height: 42, fontSize: 9 },
      treatmentHospital: { page: 0, formPage: '1/3', x: 395, y: 406, width: 130, height: 16, fontSize: 10 },
      diagnosis: { page: 0, formPage: '1/3', x: 395, y: 384, width: 130, height: 16, fontSize: 10 },
      bank: { page: 0, formPage: '1/3', x: 145, y: 222, width: 70, height: 16, fontSize: 10 },
      accountNumber: { page: 0, formPage: '1/3', x: 255, y: 222, width: 155, height: 16, fontSize: 10 },
      accountHolder: { page: 0, formPage: '1/3', x: 480, y: 222, width: 55, height: 16, fontSize: 10 },
      writtenYear: { page: 0, formPage: '1/3', fontSize: 9.5, digitsOnly: true, valign: 'center', cellBoxes: makeCells(103.5, 71, 4, 19, 14) },
      writtenMonth: { page: 0, formPage: '1/3', fontSize: 9.5, digitsOnly: true, valign: 'center', cellBoxes: makeCells(197, 71, 2, 19, 14) },
      writtenDay: { page: 0, formPage: '1/3', fontSize: 9.5, digitsOnly: true, valign: 'center', cellBoxes: makeCells(247.5, 71, 2, 19, 14) },
      signatureName: { page: 0, formPage: '1/3', x: 365, y: 70, width: 82, height: 16, fontSize: 10, align: 'center', valign: 'center' },
      signature: { page: 0, formPage: '1/3', x: 451, y: 69, width: 42, height: 16, fit: 'contain' },
      consentWrittenYear: { page: 2, formPage: '3/3', x: 202, y: 72, width: 38, height: 16, fontSize: 10, align: 'center', valign: 'center' },
      consentWrittenMonth: { page: 2, formPage: '3/3', x: 269, y: 72, width: 31, height: 16, fontSize: 10, align: 'center', valign: 'center' },
      consentWrittenDay: { page: 2, formPage: '3/3', x: 325, y: 72, width: 27, height: 16, fontSize: 10, align: 'center', valign: 'center' },
      consentSignatureName: { page: 2, formPage: '3/3', x: 455, y: 96, width: 57, height: 16, fontSize: 10, align: 'center', valign: 'center' },
      consentSignature: { page: 2, formPage: '3/3', x: 514, y: 97, width: 24, height: 14, fit: 'contain' },
    },
    checkboxes: {
      claimType: {
        injury: { page: 0, formPage: '1/3', x: 105, y: 464.5, boxWidth: 17, boxHeight: 13, markSize: 14, lineWidth: 2.7 },
        disease: { page: 0, formPage: '1/3', x: 168.5, y: 464.5, boxWidth: 17, boxHeight: 13, markSize: 14, lineWidth: 2.7 },
        traffic: { page: 0, formPage: '1/3', x: 233.5, y: 464.5, boxWidth: 17, boxHeight: 13, markSize: 14, lineWidth: 2.7 },
      },
      receiptType: {
        additional: { page: 0, formPage: '1/3', x: 337.5, y: 464.5, boxWidth: 17, boxHeight: 13, markSize: 14, lineWidth: 2.7 },
      },
      autoInsuranceProcessed: {
        no: { page: 0, formPage: '1/3', x: 165.5, y: 360.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        yes: { page: 0, formPage: '1/3', x: 226.5, y: 360.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
      },
      vehicleOccupant: {
        driver: { page: 0, formPage: '1/3', x: 270, y: 336.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        frontPassenger: { page: 0, formPage: '1/3', x: 316.5, y: 336.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        rearPassenger: { page: 0, formPage: '1/3', x: 363.5, y: 336.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        pedestrian: { page: 0, formPage: '1/3', x: 410.5, y: 336.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        other: { page: 0, formPage: '1/3', x: 457, y: 336.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
      },
      noticeRecipient: {
        policyholder: { page: 0, formPage: '1/3', x: 112.5, y: 618, boxWidth: 17, boxHeight: 15, markSize: 14, lineWidth: 2.7 },
        insured: { page: 0, formPage: '1/3', x: 206.5, y: 618, boxWidth: 17, boxHeight: 15, markSize: 14, lineWidth: 2.7 },
        other: { page: 0, formPage: '1/3', x: 292.5, y: 618, boxWidth: 17, boxHeight: 15, markSize: 14, lineWidth: 2.7 },
      },
      autoTransfer: {
        receiveSamePerson: { page: 0, formPage: '1/3', x: 86.5, y: 281.5, size: 12, lineWidth: 2.5 },
      },
      partialClaimCoverage: {
        inpatient: { page: 0, formPage: '1/3', x: 96, y: 309.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        outpatient: { page: 0, formPage: '1/3', x: 158.5, y: 309.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        surgery: { page: 0, formPage: '1/3', x: 221, y: 309.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        diagnosis: { page: 0, formPage: '1/3', x: 283.5, y: 309.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        death: { page: 0, formPage: '1/3', x: 346, y: 309.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        disability: { page: 0, formPage: '1/3', x: 408.5, y: 309.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
        driver: { page: 0, formPage: '1/3', x: 471, y: 309.5, boxWidth: 17, boxHeight: 16, markSize: 14, lineWidth: 2.7 },
      },
      autoTransferRequest: { page: 0, formPage: '1/3', x: 105.5, y: 251.5, boxWidth: 17, boxHeight: 17, markSize: 14, lineWidth: 2.7 },
    },
    consents: {
      collectUniqueId: {
        label: '고유식별정보 수집·이용 동의',
        required: true,
        page: 1,
        formPage: '2/3',
        disagree: { x: 422, y: 504.5, boxWidth: 10, boxHeight: 10, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 504.5, boxWidth: 10, boxHeight: 10, markSize: 8.5, lineWidth: 1.8 },
      },
      collectSensitive: {
        label: '민감정보 수집·이용 동의',
        required: true,
        page: 1,
        formPage: '2/3',
        disagree: { x: 422, y: 439.5, boxWidth: 10, boxHeight: 10, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 439.5, boxWidth: 10, boxHeight: 10, markSize: 8.5, lineWidth: 1.8 },
      },
      collectPersonalCredit: {
        label: '개인(신용)정보 수집·이용 동의',
        required: true,
        page: 1,
        formPage: '2/3',
        disagree: { x: 422, y: 339.5, boxWidth: 10, boxHeight: 10, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 339.5, boxWidth: 10, boxHeight: 10, markSize: 8.5, lineWidth: 1.8 },
      },
      provideUniqueId: {
        label: '고유식별정보 제공 동의',
        required: true,
        page: 2,
        formPage: '3/3',
        disagree: { x: 422, y: 717, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 717, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
      },
      provideSensitive: {
        label: '민감정보 제공 동의',
        required: true,
        page: 2,
        formPage: '3/3',
        disagree: { x: 422, y: 649, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 649, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
      },
      providePersonalCredit: {
        label: '개인(신용)정보 제공 동의',
        required: true,
        page: 2,
        formPage: '3/3',
        disagree: { x: 422, y: 558, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 558, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
      },
      providePersonalCreditOverseas: {
        label: '국외 개인(신용)정보 제공 동의',
        required: false,
        page: 2,
        formPage: '3/3',
        disagree: { x: 422, y: 478, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 478, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
      },
      queryUniqueId: {
        label: '고유식별정보 조회 동의',
        required: true,
        page: 2,
        formPage: '3/3',
        disagree: { x: 422, y: 275, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 275, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
      },
      querySensitive: {
        label: '민감정보 조회 동의',
        required: true,
        page: 2,
        formPage: '3/3',
        disagree: { x: 422, y: 235, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 235, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
      },
      queryPersonalCredit: {
        label: '개인(신용)정보 조회 동의',
        required: true,
        page: 2,
        formPage: '3/3',
        disagree: { x: 422, y: 132, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
        agree: { x: 498, y: 132, boxWidth: 9.5, boxHeight: 9.5, markSize: 8.5, lineWidth: 1.8 },
      },
      assignmentNotice: {
        label: '채권 양도 안내사항 동의',
        required: false,
        page: 0,
        formPage: '1/3',
        agree: { x: 508.5, y: 160, boxWidth: 17, boxHeight: 17, markSize: 14, lineWidth: 2.7 },
      },
    },
  },
};

export function getClaimFormTemplateByCompany(companyName) {
  const key = String(companyName || '').trim();
  if (!key) return null;

  return (
    Object.values(CLAIM_FORM_TEMPLATES).find(
      (template) =>
        template.companyName === key ||
        template.companyId === key ||
        template.aliases?.includes(key)
    ) || null
  );
}
